var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/forward"
  }, /*#__PURE__*/React.createElement("g", {
    id: "forward"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 8.34032V15.6603C2 17.1603 3.63 18.1003 4.93 17.3503L8.1 15.5203L11.27 13.6903L11.76 13.4103V10.5903L11.27 10.3103L8.1 8.48032L4.93 6.65032C3.63 5.90032 2 6.84032 2 8.34032Z",
    fill: "#FFAF00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.76 8.34032V15.6603C11.76 17.1603 13.39 18.1003 14.68 17.3503L17.86 15.5203L21.03 13.6903C22.32 12.9403 22.32 11.0603 21.03 10.3103L17.86 8.48032L14.68 6.65032C13.39 5.90032 11.76 6.84032 11.76 8.34032Z",
    fill: "#FFAF00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkip);
export default __webpack_public_path__ + "static/media/skip.6bd432bdccb499901889a43de8b62cc8.svg";
export { ForwardRef as ReactComponent };